<template>
  <transition name="fade">
    <div>
      <Loader v-if="!currentComponent" class="mr-2 mt-6" />
      <component v-else :is="currentComponent" />
    </div>
  </transition>
</template>

<script>
import Members from './Members.vue';
import MemberDetailsVue from './MemberDetails.vue';
import Loader from "@/components/common/loader/Loader";
import {
  mapState,
  mapActions
} from "vuex";
import {
  LOAD_ACCOUNT,
  LOAD_ORGANIZATION,

} from "@/store/_actiontypes";
export default {
    components: {
    Loader,
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  computed: {
    ...mapState({
      organization: (state) => state.account.organization,
      user: (state) => state.account.user,
      account: state => state.account.account,
    }),
    isDataLoaded() {
      return this.account && this.organization &&
        Object.keys(this.account).length > 0 &&
        Object.keys(this.organization).length > 0;
    },
  },

  async created() {
    try {
      // Run both API calls simultaneously
      const [organizationResponse, accountResponse] = await Promise.all([
        this.LOAD_ORGANIZATION(),
        this.LOAD_ACCOUNT()
      ]);

      // Extract data safely
      const isAccountOwner = organizationResponse?.data?.is_account_owner;
      const showMembersToOthers = accountResponse?.data?.show_members_to_others;

      if (showMembersToOthers == true || isAccountOwner == true) {
        this.currentComponent = this.decideComponent();

      } else {
        if (this.$route.path !== '/404') {
          this.$router.push({ path: '/404' });
        }
      }

    } catch (error) {
      console.error("Error loading data:", error);
      if (this.$route.path !== '/404') {
        this.$router.push({ path: '/404' });
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: false,
      async handler() {
        if (!this.isDataLoaded) return;

        try {
          // Run both API calls in parallel
          const [organizationResponse, accountResponse] = await Promise.all([
            this.LOAD_ORGANIZATION(),
            this.LOAD_ACCOUNT()
          ]);
          const isAccountOwner = organizationResponse?.data?.is_account_owner;
          const showMembersToOthers = accountResponse?.data?.show_members_to_others;


          if (isAccountOwner == true || showMembersToOthers == true) {
            this.currentComponent = this.decideComponent();
          } else {
            if (this.$route.path !== '/404') {
              this.$router.replace({ path: '/404' });
            }
          }

        } catch (error) {
          console.error("Error loading data:", error);
        }
      }
    }
  },

  methods: {
    ...mapActions("account", [
      LOAD_ORGANIZATION,
      LOAD_ACCOUNT,
    ]),
    decideComponent() {
      const { mid } = this.$route.query;
      if (this.isDataLoaded) {
        if (mid) {
          return MemberDetailsVue;
        } else {
          return Members;
        }
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>